import type * as Types from '../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type GetStationeryMostRecentShippingAddressByEventQueryVariables = Types.Exact<{
  eventId: Types.Scalars['String'];
}>;

export type GetStationeryMostRecentShippingAddressByEventQuery = {
  __typename?: 'Query';
  stationeryMostRecentShippingAddressByEvent?: {
    __typename?: 'StationeryPrintOrderShippingAddress';
    address1: string;
    address2?: string | null;
    city: string;
    country: string;
    countryCode: string;
    name: string;
    postalCode: string;
    region: string;
  } | null;
};

export type GetStationeryCardDraftByIdQueryVariables = Types.Exact<{
  id: Types.Scalars['String'];
}>;

export type GetStationeryCardDraftByIdQuery = {
  __typename?: 'Query';
  stationeryDraftById?: {
    __typename?: 'StationeryDraft';
    cardJSON: any;
    eventId?: string | null;
    format: Types.StationeryDraftFormat;
    id: string;
    stationeryTemplate: {
      __typename?: 'StationeryTemplate';
      id: string;
      category: Types.StationeryTemplateCategoryEnum;
      name?: string | null;
      themeId: string;
      products: Array<{
        __typename?: 'StationeryProduct';
        id: string;
        priceConfigId: string;
        vendor: Types.StationeryPrintOrderVendorEnum;
        productType: string;
        vendorBaseSKU: string;
        priceCurrency: string;
        shippingOptions?: Array<{
          __typename?: 'StationeryProductShippingOptionV1';
          id: string;
          pricing:
            | { __typename?: 'StationeryFlatFeePricing'; priceInMinorUnits: number }
            | {
                __typename?: 'StationeryTieredFlatFeePricing';
                priceTiers: Array<{ __typename?: 'StationeryTieredFlatFeePrice'; minQuantity: number; totalPriceInMinorUnits: number }>;
              }
            | { __typename?: 'StationeryTieredPricing'; priceTiers: Array<{ __typename?: 'StationeryTieredPrice'; minQuantity: number; unitPriceInMinorUnits: number }> };
          constraints: Array<
            | { __typename?: 'StationeryAllowPoBoxShippingConstraint'; allowPoBox: boolean }
            | { __typename?: 'StationeryCountryShippingConstraint'; includedCountries?: Array<string> | null; excludedCountries?: Array<string> | null }
            | { __typename?: 'StationeryQuantityShippingConstraint'; minQuantity: number; maxQuantity?: number | null }
          >;
        }> | null;
        attributes: Array<{
          __typename?: 'StationeryProductAttribute';
          attributeId: string;
          attributeOptions: Array<{
            __typename?: 'StationeryProductAttributeOption';
            attributeOption: { __typename?: 'StationeryAttributeOption'; attributeId: string; id: string };
            pricing:
              | { __typename?: 'StationeryFlatFeePricing'; priceInMinorUnits: number }
              | {
                  __typename?: 'StationeryTieredFlatFeePricing';
                  priceTiers: Array<{ __typename?: 'StationeryTieredFlatFeePrice'; minQuantity: number; totalPriceInMinorUnits: number }>;
                }
              | { __typename?: 'StationeryTieredPricing'; priceTiers: Array<{ __typename?: 'StationeryTieredPrice'; minQuantity: number; unitPriceInMinorUnits: number }> };
          }>;
        }>;
        pricing:
          | { __typename?: 'StationeryFlatFeePricing'; priceInMinorUnits: number }
          | {
              __typename?: 'StationeryTieredFlatFeePricing';
              priceTiers: Array<{ __typename?: 'StationeryTieredFlatFeePrice'; minQuantity: number; totalPriceInMinorUnits: number }>;
            }
          | { __typename?: 'StationeryTieredPricing'; priceTiers: Array<{ __typename?: 'StationeryTieredPrice'; minQuantity: number; unitPriceInMinorUnits: number }> };
        variantGroups: Array<{
          __typename?: 'StationeryProductVariantGroup';
          vendorSKU: string;
          id: string;
          options: Array<{ __typename?: 'StationeryAttributeOption'; id: string; attributeId: string }>;
        }>;
      }>;
    };
    product?: { __typename?: 'StationeryProduct'; id: string; productType: string } | null;
  } | null;
};

export type StationeryPrintOrderShippingAddressFragment = {
  __typename?: 'StationeryPrintOrderShippingAddress';
  address1: string;
  address2?: string | null;
  city: string;
  country: string;
  countryCode: string;
  name: string;
  postalCode: string;
  region: string;
};

export type OrderProductDetailsFragment = {
  __typename?: 'StationeryPrintOrder';
  product?: {
    __typename?: 'StationeryProduct';
    id: string;
    priceConfigId: string;
    vendor: Types.StationeryPrintOrderVendorEnum;
    productType: string;
    vendorBaseSKU: string;
    priceCurrency: string;
    shippingOptions?: Array<{
      __typename?: 'StationeryProductShippingOptionV1';
      id: string;
      pricing:
        | { __typename?: 'StationeryFlatFeePricing'; priceInMinorUnits: number }
        | { __typename?: 'StationeryTieredFlatFeePricing'; priceTiers: Array<{ __typename?: 'StationeryTieredFlatFeePrice'; minQuantity: number; totalPriceInMinorUnits: number }> }
        | { __typename?: 'StationeryTieredPricing'; priceTiers: Array<{ __typename?: 'StationeryTieredPrice'; minQuantity: number; unitPriceInMinorUnits: number }> };
      constraints: Array<
        | { __typename?: 'StationeryAllowPoBoxShippingConstraint'; allowPoBox: boolean }
        | { __typename?: 'StationeryCountryShippingConstraint'; includedCountries?: Array<string> | null; excludedCountries?: Array<string> | null }
        | { __typename?: 'StationeryQuantityShippingConstraint'; minQuantity: number; maxQuantity?: number | null }
      >;
    }> | null;
    attributes: Array<{
      __typename?: 'StationeryProductAttribute';
      attributeId: string;
      attributeOptions: Array<{
        __typename?: 'StationeryProductAttributeOption';
        attributeOption: { __typename?: 'StationeryAttributeOption'; attributeId: string; id: string };
        pricing:
          | { __typename?: 'StationeryFlatFeePricing'; priceInMinorUnits: number }
          | {
              __typename?: 'StationeryTieredFlatFeePricing';
              priceTiers: Array<{ __typename?: 'StationeryTieredFlatFeePrice'; minQuantity: number; totalPriceInMinorUnits: number }>;
            }
          | { __typename?: 'StationeryTieredPricing'; priceTiers: Array<{ __typename?: 'StationeryTieredPrice'; minQuantity: number; unitPriceInMinorUnits: number }> };
      }>;
    }>;
    pricing:
      | { __typename?: 'StationeryFlatFeePricing'; priceInMinorUnits: number }
      | { __typename?: 'StationeryTieredFlatFeePricing'; priceTiers: Array<{ __typename?: 'StationeryTieredFlatFeePrice'; minQuantity: number; totalPriceInMinorUnits: number }> }
      | { __typename?: 'StationeryTieredPricing'; priceTiers: Array<{ __typename?: 'StationeryTieredPrice'; minQuantity: number; unitPriceInMinorUnits: number }> };
    variantGroups: Array<{
      __typename?: 'StationeryProductVariantGroup';
      vendorSKU: string;
      id: string;
      options: Array<{ __typename?: 'StationeryAttributeOption'; id: string; attributeId: string }>;
    }>;
  } | null;
};

export type GetStationaryPrintOrderByOrderNumberQueryVariables = Types.Exact<{
  orderNumber: Types.Scalars['String'];
}>;

export type GetStationaryPrintOrderByOrderNumberQuery = {
  __typename?: 'Query';
  stationeryPrintOrderByOrderNumber?: {
    __typename?: 'StationeryPrintOrder';
    id: string;
    priceInMinorUnits: number;
    deliveryMethod: Types.StationeryPrintOrderDeliveryMethodEnum;
    orderNumber: string;
    formLink?: string | null;
    magnetCard?: boolean | null;
    quantity: number;
    taxInMinorUnits?: number | null;
    printCardFrontPreviewUrl: string;
    printCardBackPreviewUrl: string;
    envelopeBackImageUrl?: string | null;
    envelopeFrontImageUrl?: string | null;
    cardDraftJSONBlob?: any | null;
    cardDraft?: {
      __typename?: 'StationeryDraft';
      id: string;
      cardJSON: any;
      format: Types.StationeryDraftFormat;
      stationeryTemplate: {
        __typename?: 'StationeryTemplate';
        id: string;
        category: Types.StationeryTemplateCategoryEnum;
        themeId: string;
        products: Array<{
          __typename?: 'StationeryProduct';
          id: string;
          priceConfigId: string;
          vendor: Types.StationeryPrintOrderVendorEnum;
          productType: string;
          vendorBaseSKU: string;
          priceCurrency: string;
          shippingOptions?: Array<{
            __typename?: 'StationeryProductShippingOptionV1';
            id: string;
            pricing:
              | { __typename?: 'StationeryFlatFeePricing'; priceInMinorUnits: number }
              | {
                  __typename?: 'StationeryTieredFlatFeePricing';
                  priceTiers: Array<{ __typename?: 'StationeryTieredFlatFeePrice'; minQuantity: number; totalPriceInMinorUnits: number }>;
                }
              | { __typename?: 'StationeryTieredPricing'; priceTiers: Array<{ __typename?: 'StationeryTieredPrice'; minQuantity: number; unitPriceInMinorUnits: number }> };
            constraints: Array<
              | { __typename?: 'StationeryAllowPoBoxShippingConstraint'; allowPoBox: boolean }
              | { __typename?: 'StationeryCountryShippingConstraint'; includedCountries?: Array<string> | null; excludedCountries?: Array<string> | null }
              | { __typename?: 'StationeryQuantityShippingConstraint'; minQuantity: number; maxQuantity?: number | null }
            >;
          }> | null;
          attributes: Array<{
            __typename?: 'StationeryProductAttribute';
            attributeId: string;
            attributeOptions: Array<{
              __typename?: 'StationeryProductAttributeOption';
              attributeOption: { __typename?: 'StationeryAttributeOption'; attributeId: string; id: string };
              pricing:
                | { __typename?: 'StationeryFlatFeePricing'; priceInMinorUnits: number }
                | {
                    __typename?: 'StationeryTieredFlatFeePricing';
                    priceTiers: Array<{ __typename?: 'StationeryTieredFlatFeePrice'; minQuantity: number; totalPriceInMinorUnits: number }>;
                  }
                | { __typename?: 'StationeryTieredPricing'; priceTiers: Array<{ __typename?: 'StationeryTieredPrice'; minQuantity: number; unitPriceInMinorUnits: number }> };
            }>;
          }>;
          pricing:
            | { __typename?: 'StationeryFlatFeePricing'; priceInMinorUnits: number }
            | {
                __typename?: 'StationeryTieredFlatFeePricing';
                priceTiers: Array<{ __typename?: 'StationeryTieredFlatFeePrice'; minQuantity: number; totalPriceInMinorUnits: number }>;
              }
            | { __typename?: 'StationeryTieredPricing'; priceTiers: Array<{ __typename?: 'StationeryTieredPrice'; minQuantity: number; unitPriceInMinorUnits: number }> };
          variantGroups: Array<{
            __typename?: 'StationeryProductVariantGroup';
            vendorSKU: string;
            id: string;
            options: Array<{ __typename?: 'StationeryAttributeOption'; id: string; attributeId: string }>;
          }>;
        }>;
      };
      product?: { __typename?: 'StationeryProduct'; id: string; productType: string } | null;
    } | null;
    statusHistory: Array<{ __typename?: 'StationeryPrintOrderStatus'; id: string; date: any; status: Types.StationeryPrintOrderStatusEnum }>;
    shippingAddress?: {
      __typename?: 'StationeryPrintOrderShippingAddress';
      address1: string;
      address2?: string | null;
      city: string;
      country: string;
      countryCode: string;
      name: string;
      postalCode: string;
      region: string;
    } | null;
    discount?: { __typename?: 'StationeryPrintOrderDiscount'; code: string; discountPercentage?: number | null; discountAmountInMinorUnits: any } | null;
    issues: Array<{
      __typename?: 'StationeryPrintOrderIssue';
      id: string;
      resolvedAt?: any | null;
      issueType: Types.StationeryPrintOrderIssueType;
      issueTarget: Types.StationeryPrintOrderIssueTarget;
    }>;
    product?: {
      __typename?: 'StationeryProduct';
      id: string;
      priceConfigId: string;
      vendor: Types.StationeryPrintOrderVendorEnum;
      productType: string;
      vendorBaseSKU: string;
      priceCurrency: string;
      shippingOptions?: Array<{
        __typename?: 'StationeryProductShippingOptionV1';
        id: string;
        pricing:
          | { __typename?: 'StationeryFlatFeePricing'; priceInMinorUnits: number }
          | {
              __typename?: 'StationeryTieredFlatFeePricing';
              priceTiers: Array<{ __typename?: 'StationeryTieredFlatFeePrice'; minQuantity: number; totalPriceInMinorUnits: number }>;
            }
          | { __typename?: 'StationeryTieredPricing'; priceTiers: Array<{ __typename?: 'StationeryTieredPrice'; minQuantity: number; unitPriceInMinorUnits: number }> };
        constraints: Array<
          | { __typename?: 'StationeryAllowPoBoxShippingConstraint'; allowPoBox: boolean }
          | { __typename?: 'StationeryCountryShippingConstraint'; includedCountries?: Array<string> | null; excludedCountries?: Array<string> | null }
          | { __typename?: 'StationeryQuantityShippingConstraint'; minQuantity: number; maxQuantity?: number | null }
        >;
      }> | null;
      attributes: Array<{
        __typename?: 'StationeryProductAttribute';
        attributeId: string;
        attributeOptions: Array<{
          __typename?: 'StationeryProductAttributeOption';
          attributeOption: { __typename?: 'StationeryAttributeOption'; attributeId: string; id: string };
          pricing:
            | { __typename?: 'StationeryFlatFeePricing'; priceInMinorUnits: number }
            | {
                __typename?: 'StationeryTieredFlatFeePricing';
                priceTiers: Array<{ __typename?: 'StationeryTieredFlatFeePrice'; minQuantity: number; totalPriceInMinorUnits: number }>;
              }
            | { __typename?: 'StationeryTieredPricing'; priceTiers: Array<{ __typename?: 'StationeryTieredPrice'; minQuantity: number; unitPriceInMinorUnits: number }> };
        }>;
      }>;
      pricing:
        | { __typename?: 'StationeryFlatFeePricing'; priceInMinorUnits: number }
        | { __typename?: 'StationeryTieredFlatFeePricing'; priceTiers: Array<{ __typename?: 'StationeryTieredFlatFeePrice'; minQuantity: number; totalPriceInMinorUnits: number }> }
        | { __typename?: 'StationeryTieredPricing'; priceTiers: Array<{ __typename?: 'StationeryTieredPrice'; minQuantity: number; unitPriceInMinorUnits: number }> };
      variantGroups: Array<{
        __typename?: 'StationeryProductVariantGroup';
        vendorSKU: string;
        id: string;
        options: Array<{ __typename?: 'StationeryAttributeOption'; id: string; attributeId: string }>;
      }>;
    } | null;
  } | null;
};

export type GetEventPrivacyForCardCustomizerQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
}>;

export type GetEventPrivacyForCardCustomizerQuery = {
  __typename?: 'Query';
  eventById?: {
    __typename?: 'Event';
    id: string;
    info: { __typename?: 'EventInfo'; id: string; hasEventPassword: boolean };
    settings: { __typename?: 'EventSettings'; id: string; privacyMode: Types.PrivacyModeType };
  } | null;
};

export type CreateStationeryDraftPreviewMutationVariables = Types.Exact<{
  data: Types.CreateStationeryDraftPreviewInput;
}>;

export type CreateStationeryDraftPreviewMutation = {
  __typename?: 'Mutation';
  createStationeryDraftPreview?: {
    __typename?: 'StationeryDraftPreview';
    stationeryPDF: string;
    stationeryFrontImage: string;
    stationeryBackImage?: string | null;
    envelopePDF?: string | null;
    envelopeFrontImage?: string | null;
    envelopeBackImage?: string | null;
    postcardBacksPDF?: string | null;
    postcardBackImage?: string | null;
    postcardInterleavedPDF?: string | null;
  } | null;
};

export type CreateStationeryDigitalDraftPreviewMutationVariables = Types.Exact<{
  data: Types.CreateStationeryDraftPreviewInput;
}>;

export type CreateStationeryDigitalDraftPreviewMutation = {
  __typename?: 'Mutation';
  createStationeryDigitalDraftPreview?: {
    __typename?: 'StationeryDigitalDraftPreview';
    stationeryFrontImage: string;
    stationeryBackImage: string;
    digitalEnvelopeImage: string;
  } | null;
};

export type UpdateStationeryDraftMutationVariables = Types.Exact<{
  payload: Types.UpdateStationeryDraftInput;
}>;

export type UpdateStationeryDraftMutation = {
  __typename?: 'Mutation';
  updateStationeryDraft: { __typename?: 'StationeryDraft'; id: string; cardJSON: any; eventId?: string | null; ownerId: string; updatedAt: any };
};

export type CreateStationeryPrintOrderMutationVariables = Types.Exact<{
  data: Types.CreateStationeryPrintOrderInput;
}>;

export type CreateStationeryPrintOrderMutation = {
  __typename?: 'Mutation';
  createStationeryPrintOrder?: { __typename?: 'StationeryPrintOrder'; id: string; orderNumber: string } | null;
};

export type AddStationeryCartItemMutationVariables = Types.Exact<{
  data: Types.CreateStationeryPrintOrderInput;
}>;

export type AddStationeryCartItemMutation = { __typename?: 'Mutation'; addStationeryCartItem?: { __typename?: 'StationeryPrintOrder'; id: string; orderNumber: string } | null };

export type StartStationeryCheckoutMutationVariables = Types.Exact<{
  payload: Types.StartStationeryCheckoutInput;
}>;

export type StartStationeryCheckoutMutation = { __typename?: 'Mutation'; startStationeryCheckout: { __typename?: 'StartStationeryCheckoutResponse'; checkoutUrl?: string | null } };

export type DeleteStationeryPrintOrderForFailedCheckoutUrlMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;

export type DeleteStationeryPrintOrderForFailedCheckoutUrlMutation = {
  __typename?: 'Mutation';
  deleteStationeryPrintOrderForFailedCheckoutUrl: { __typename?: 'StationeryPrintOrder'; id: string };
};

export type UpdateWebsiteHandleMutationVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
  website: Types.Scalars['String'];
}>;

export type UpdateWebsiteHandleMutation = { __typename?: 'Mutation'; updateWebsiteHandle: { __typename?: 'Event'; id: string; website: string } };

export type CreateQRCodeMutationVariables = Types.Exact<{
  data: Types.CreateQRCodeInput;
}>;

export type CreateQRCodeMutation = { __typename?: 'Mutation'; createQRCode: string };

export type EditStationeryPrintOrderMutationVariables = Types.Exact<{
  data: Types.EditStationeryPrintOrderInput;
}>;

export type EditStationeryPrintOrderMutation = {
  __typename?: 'Mutation';
  editStationeryPrintOrder: {
    __typename?: 'StationeryPrintOrder';
    id: string;
    eventId?: string | null;
    ownerId: string;
    createdAt: any;
    vendor: Types.StationeryPrintOrderVendorEnum;
    currentStatus: Types.StationeryPrintOrderStatusEnum;
    deliveryMethod: Types.StationeryPrintOrderDeliveryMethodEnum;
    quantity: number;
    priceInMinorUnits: number;
    taxInMinorUnits?: number | null;
    currencyConversionData?: any | null;
    currencyISO4217?: string | null;
    pricingAsCustomized?: any | null;
    cardDraftJSONBlob?: any | null;
    digitalFeatures?: Array<string> | null;
    orderNumber: string;
    printCardFrontPreviewUrl: string;
    printCardBackPreviewUrl: string;
    postcardBackImageUrl?: string | null;
    envelopeFrontImageUrl?: string | null;
    envelopeBackImageUrl?: string | null;
    stationeryPDFUrl: string;
    postcardInterleavedPDFUrl?: string | null;
    envelopePDFUrl?: string | null;
    state: Types.StationeryPrintOrderStateEnum;
    designSetName?: string | null;
    magnetCard?: boolean | null;
    statusHistory: Array<{ __typename?: 'StationeryPrintOrderStatus'; id: string; orderId: string; status: Types.StationeryPrintOrderStatusEnum; date: any }>;
    shippingAddress?: {
      __typename?: 'StationeryPrintOrderShippingAddress';
      name: string;
      address1: string;
      address2?: string | null;
      city: string;
      postalCode: string;
      region: string;
      country: string;
      countryCode: string;
    } | null;
    printPayment?: {
      __typename?: 'StationeryPrintOrderPayment';
      id: string;
      paid: boolean;
      paidAt?: any | null;
      paymentInfo?: { __typename?: 'StationeryPrintOrderPaymentInfo'; creditCardBrand: string; creditCardLast4: string } | null;
    } | null;
    cardDraft?: {
      __typename?: 'StationeryDraft';
      id: string;
      format: Types.StationeryDraftFormat;
      stationeryTemplate: {
        __typename?: 'StationeryTemplate';
        id: string;
        name?: string | null;
        themeId: string;
        category: Types.StationeryTemplateCategoryEnum;
        products: Array<{ __typename?: 'StationeryProduct'; id: string; productType: string }>;
      };
    } | null;
    trackingNumbers: Array<{ __typename?: 'StationeryPrintTrackingNumberView'; trackingUrl: string }>;
    refunds: Array<{ __typename?: 'StationeryPrintOrderRefundView'; refundAmountInMinorUnits: number }>;
    discount?: { __typename?: 'StationeryPrintOrderDiscount'; code: string; discountAmountInMinorUnits: any; discountPercentage?: number | null } | null;
    issues: Array<{
      __typename?: 'StationeryPrintOrderIssue';
      id: string;
      resolvedAt?: any | null;
      issueType: Types.StationeryPrintOrderIssueType;
      issueTarget: Types.StationeryPrintOrderIssueTarget;
      additionalUserFacingDescription?: string | null;
    }>;
    product?: {
      __typename?: 'StationeryProduct';
      id: string;
      priceConfigId: string;
      vendor: Types.StationeryPrintOrderVendorEnum;
      productType: string;
      vendorBaseSKU: string;
      priceCurrency: string;
      shippingOptions?: Array<{
        __typename?: 'StationeryProductShippingOptionV1';
        id: string;
        pricing:
          | { __typename?: 'StationeryFlatFeePricing'; priceInMinorUnits: number }
          | {
              __typename?: 'StationeryTieredFlatFeePricing';
              priceTiers: Array<{ __typename?: 'StationeryTieredFlatFeePrice'; minQuantity: number; totalPriceInMinorUnits: number }>;
            }
          | { __typename?: 'StationeryTieredPricing'; priceTiers: Array<{ __typename?: 'StationeryTieredPrice'; minQuantity: number; unitPriceInMinorUnits: number }> };
        constraints: Array<
          | { __typename?: 'StationeryAllowPoBoxShippingConstraint'; allowPoBox: boolean }
          | { __typename?: 'StationeryCountryShippingConstraint'; includedCountries?: Array<string> | null; excludedCountries?: Array<string> | null }
          | { __typename?: 'StationeryQuantityShippingConstraint'; minQuantity: number; maxQuantity?: number | null }
        >;
      }> | null;
      attributes: Array<{
        __typename?: 'StationeryProductAttribute';
        attributeId: string;
        attributeOptions: Array<{
          __typename?: 'StationeryProductAttributeOption';
          attributeOption: { __typename?: 'StationeryAttributeOption'; attributeId: string; id: string };
          pricing:
            | { __typename?: 'StationeryFlatFeePricing'; priceInMinorUnits: number }
            | {
                __typename?: 'StationeryTieredFlatFeePricing';
                priceTiers: Array<{ __typename?: 'StationeryTieredFlatFeePrice'; minQuantity: number; totalPriceInMinorUnits: number }>;
              }
            | { __typename?: 'StationeryTieredPricing'; priceTiers: Array<{ __typename?: 'StationeryTieredPrice'; minQuantity: number; unitPriceInMinorUnits: number }> };
        }>;
      }>;
      pricing:
        | { __typename?: 'StationeryFlatFeePricing'; priceInMinorUnits: number }
        | { __typename?: 'StationeryTieredFlatFeePricing'; priceTiers: Array<{ __typename?: 'StationeryTieredFlatFeePrice'; minQuantity: number; totalPriceInMinorUnits: number }> }
        | { __typename?: 'StationeryTieredPricing'; priceTiers: Array<{ __typename?: 'StationeryTieredPrice'; minQuantity: number; unitPriceInMinorUnits: number }> };
      variantGroups: Array<{
        __typename?: 'StationeryProductVariantGroup';
        vendorSKU: string;
        id: string;
        options: Array<{ __typename?: 'StationeryAttributeOption'; id: string; attributeId: string }>;
      }>;
    } | null;
    selectedProduct?: {
      __typename?: 'StationeryPrintOrderSelectedProduct';
      attributes: Array<{ __typename?: 'StationeryPrintOrderProductAttribute'; attributeId: string; optionId: string }>;
    } | null;
  };
};

export type CreateAndStartCheckoutDigitalPrintOrderMutationVariables = Types.Exact<{
  data: Types.CreateDigitalPrintOrderInput;
}>;

export type CreateAndStartCheckoutDigitalPrintOrderMutation = {
  __typename?: 'Mutation';
  createAndStartCheckoutDigitalPrintOrder: { __typename?: 'StartStationeryCheckoutResponse'; checkoutUrl?: string | null };
};

export type AddStationeryPrintOrderIssuesMutationVariables = Types.Exact<{
  stationeryPrintOrderId: Types.Scalars['ID'];
  data: Array<Types.CreateStationeryPrintOrderIssueInput> | Types.CreateStationeryPrintOrderIssueInput;
}>;

export type AddStationeryPrintOrderIssuesMutation = {
  __typename?: 'Mutation';
  addStationeryPrintOrderIssues: {
    __typename?: 'StationeryPrintOrder';
    id: string;
    issues: Array<{
      __typename?: 'StationeryPrintOrderIssue';
      id: string;
      resolvedAt?: any | null;
      issueType: Types.StationeryPrintOrderIssueType;
      issueTarget: Types.StationeryPrintOrderIssueTarget;
    }>;
  };
};

export type ResolveStationeryPrintOrderIssueMutationVariables = Types.Exact<{
  stationeryPrintOrderId: Types.Scalars['ID'];
  issueId: Types.Scalars['ID'];
}>;

export type ResolveStationeryPrintOrderIssueMutation = {
  __typename?: 'Mutation';
  resolveStationeryPrintOrderIssue: {
    __typename?: 'StationeryPrintOrder';
    id: string;
    issues: Array<{
      __typename?: 'StationeryPrintOrderIssue';
      id: string;
      resolvedAt?: any | null;
      issueType: Types.StationeryPrintOrderIssueType;
      issueTarget: Types.StationeryPrintOrderIssueTarget;
      additionalUserFacingDescription?: string | null;
    }>;
  };
};

export const StationeryPrintOrderShippingAddressFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StationeryPrintOrderShippingAddress' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryPrintOrderShippingAddress' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'region' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const OrderProductDetailsFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OrderProductDetails' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryPrintOrder' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'product' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'priceConfigId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'productType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vendorBaseSKU' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StationeryShippingOptions' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StationeryProductAttributes' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StationeryProductPricings' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StationeryProductVariantGroups' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StationeryShippingOptions' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryProduct' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shippingOptions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryProductShippingOptionV1' } },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ShippingOptionV1' } }] },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ShippingOptionV1' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryProductShippingOptionV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StationeryShippingOptionsPricing' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StationeryShippingConstraints' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StationeryShippingOptionsPricing' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryProductShippingOptionV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pricing' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryFlatFeePricing' } },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'priceInMinorUnits' } }] },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryTieredFlatFeePricing' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'priceTiers' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'minQuantity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalPriceInMinorUnits' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryTieredPricing' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'priceTiers' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'minQuantity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'unitPriceInMinorUnits' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StationeryShippingConstraints' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryProductShippingOptionV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'constraints' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryAllowPoBoxShippingConstraint' } },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'allowPoBox' } }] },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryCountryShippingConstraint' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'includedCountries' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'excludedCountries' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryQuantityShippingConstraint' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'minQuantity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maxQuantity' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StationeryProductAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryProduct' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'attributeId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attributeOptions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StationeryProductAttributePricings' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributeOption' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'attributeId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StationeryProductAttributePricings' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryProductAttributeOption' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pricing' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryTieredPricing' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'priceTiers' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'minQuantity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'unitPriceInMinorUnits' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryTieredFlatFeePricing' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'priceTiers' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'minQuantity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalPriceInMinorUnits' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryFlatFeePricing' } },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'priceInMinorUnits' } }] },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StationeryProductPricings' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryProduct' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priceCurrency' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pricing' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryTieredPricing' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'priceTiers' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'minQuantity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'unitPriceInMinorUnits' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryTieredFlatFeePricing' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'priceTiers' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'minQuantity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalPriceInMinorUnits' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryFlatFeePricing' } },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'priceInMinorUnits' } }] },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StationeryProductVariantGroups' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryProduct' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'variantGroups' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'vendorSKU' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'options' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'attributeId' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const GetStationeryMostRecentShippingAddressByEventDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetStationeryMostRecentShippingAddressByEvent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stationeryMostRecentShippingAddressByEvent' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StationeryPrintOrderShippingAddress' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StationeryPrintOrderShippingAddress' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryPrintOrderShippingAddress' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'region' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetStationeryMostRecentShippingAddressByEventQuery__
 *
 * To run a query within a React component, call `useGetStationeryMostRecentShippingAddressByEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStationeryMostRecentShippingAddressByEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStationeryMostRecentShippingAddressByEventQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetStationeryMostRecentShippingAddressByEventQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetStationeryMostRecentShippingAddressByEventQuery, GetStationeryMostRecentShippingAddressByEventQueryVariables>,
) {
  return ApolloReactHooks.useQuery<GetStationeryMostRecentShippingAddressByEventQuery, GetStationeryMostRecentShippingAddressByEventQueryVariables>(
    GetStationeryMostRecentShippingAddressByEventDocument,
    baseOptions,
  );
}
export function useGetStationeryMostRecentShippingAddressByEventLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStationeryMostRecentShippingAddressByEventQuery, GetStationeryMostRecentShippingAddressByEventQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetStationeryMostRecentShippingAddressByEventQuery, GetStationeryMostRecentShippingAddressByEventQueryVariables>(
    GetStationeryMostRecentShippingAddressByEventDocument,
    baseOptions,
  );
}
export type GetStationeryMostRecentShippingAddressByEventQueryHookResult = ReturnType<typeof useGetStationeryMostRecentShippingAddressByEventQuery>;
export type GetStationeryMostRecentShippingAddressByEventLazyQueryHookResult = ReturnType<typeof useGetStationeryMostRecentShippingAddressByEventLazyQuery>;
export type GetStationeryMostRecentShippingAddressByEventQueryResult = Apollo.QueryResult<
  GetStationeryMostRecentShippingAddressByEventQuery,
  GetStationeryMostRecentShippingAddressByEventQueryVariables
>;
export const GetStationeryCardDraftByIdDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetStationeryCardDraftById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stationeryDraftById' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'cardJSON' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'format' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stationeryTemplate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'themeId' } },
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StationeryProducts' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'product' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'productType' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StationeryProducts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryTemplate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'products' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'priceConfigId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'productType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vendorBaseSKU' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StationeryShippingOptions' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StationeryProductAttributes' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StationeryProductPricings' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StationeryProductVariantGroups' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StationeryShippingOptions' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryProduct' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shippingOptions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryProductShippingOptionV1' } },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ShippingOptionV1' } }] },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ShippingOptionV1' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryProductShippingOptionV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StationeryShippingOptionsPricing' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StationeryShippingConstraints' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StationeryShippingOptionsPricing' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryProductShippingOptionV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pricing' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryFlatFeePricing' } },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'priceInMinorUnits' } }] },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryTieredFlatFeePricing' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'priceTiers' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'minQuantity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalPriceInMinorUnits' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryTieredPricing' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'priceTiers' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'minQuantity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'unitPriceInMinorUnits' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StationeryShippingConstraints' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryProductShippingOptionV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'constraints' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryAllowPoBoxShippingConstraint' } },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'allowPoBox' } }] },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryCountryShippingConstraint' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'includedCountries' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'excludedCountries' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryQuantityShippingConstraint' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'minQuantity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maxQuantity' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StationeryProductAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryProduct' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'attributeId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attributeOptions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StationeryProductAttributePricings' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributeOption' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'attributeId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StationeryProductAttributePricings' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryProductAttributeOption' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pricing' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryTieredPricing' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'priceTiers' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'minQuantity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'unitPriceInMinorUnits' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryTieredFlatFeePricing' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'priceTiers' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'minQuantity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalPriceInMinorUnits' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryFlatFeePricing' } },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'priceInMinorUnits' } }] },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StationeryProductPricings' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryProduct' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priceCurrency' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pricing' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryTieredPricing' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'priceTiers' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'minQuantity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'unitPriceInMinorUnits' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryTieredFlatFeePricing' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'priceTiers' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'minQuantity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalPriceInMinorUnits' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryFlatFeePricing' } },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'priceInMinorUnits' } }] },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StationeryProductVariantGroups' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryProduct' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'variantGroups' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'vendorSKU' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'options' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'attributeId' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetStationeryCardDraftByIdQuery__
 *
 * To run a query within a React component, call `useGetStationeryCardDraftByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStationeryCardDraftByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStationeryCardDraftByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetStationeryCardDraftByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetStationeryCardDraftByIdQuery, GetStationeryCardDraftByIdQueryVariables>) {
  return ApolloReactHooks.useQuery<GetStationeryCardDraftByIdQuery, GetStationeryCardDraftByIdQueryVariables>(GetStationeryCardDraftByIdDocument, baseOptions);
}
export function useGetStationeryCardDraftByIdLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStationeryCardDraftByIdQuery, GetStationeryCardDraftByIdQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetStationeryCardDraftByIdQuery, GetStationeryCardDraftByIdQueryVariables>(GetStationeryCardDraftByIdDocument, baseOptions);
}
export type GetStationeryCardDraftByIdQueryHookResult = ReturnType<typeof useGetStationeryCardDraftByIdQuery>;
export type GetStationeryCardDraftByIdLazyQueryHookResult = ReturnType<typeof useGetStationeryCardDraftByIdLazyQuery>;
export type GetStationeryCardDraftByIdQueryResult = Apollo.QueryResult<GetStationeryCardDraftByIdQuery, GetStationeryCardDraftByIdQueryVariables>;
export const GetStationaryPrintOrderByOrderNumberDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetStationaryPrintOrderByOrderNumber' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderNumber' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stationeryPrintOrderByOrderNumber' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'orderNumber' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'orderNumber' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'OrderProductDetails' } },
                { kind: 'Field', name: { kind: 'Name', value: 'priceInMinorUnits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deliveryMethod' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'formLink' } },
                { kind: 'Field', name: { kind: 'Name', value: 'magnetCard' } },
                { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'taxInMinorUnits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'printCardFrontPreviewUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'printCardBackPreviewUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'envelopeBackImageUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'envelopeFrontImageUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cardDraftJSONBlob' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cardDraft' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cardJSON' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'format' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stationeryTemplate' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'themeId' } },
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StationeryProducts' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'product' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'productType' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'statusHistory' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shippingAddress' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StationeryPrintOrderShippingAddress' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'discount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', alias: { kind: 'Name', value: 'discountPercentage' }, name: { kind: 'Name', value: 'percentage' } },
                      { kind: 'Field', alias: { kind: 'Name', value: 'discountAmountInMinorUnits' }, name: { kind: 'Name', value: 'amountInMinorUnits' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'resolvedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'issueType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'issueTarget' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StationeryPrintOrderShippingAddress' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryPrintOrderShippingAddress' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'region' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OrderProductDetails' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryPrintOrder' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'product' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'priceConfigId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'productType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vendorBaseSKU' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StationeryShippingOptions' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StationeryProductAttributes' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StationeryProductPricings' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StationeryProductVariantGroups' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StationeryProducts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryTemplate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'products' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'priceConfigId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'productType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vendorBaseSKU' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StationeryShippingOptions' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StationeryProductAttributes' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StationeryProductPricings' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StationeryProductVariantGroups' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StationeryShippingOptions' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryProduct' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shippingOptions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryProductShippingOptionV1' } },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ShippingOptionV1' } }] },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ShippingOptionV1' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryProductShippingOptionV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StationeryShippingOptionsPricing' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StationeryShippingConstraints' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StationeryShippingOptionsPricing' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryProductShippingOptionV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pricing' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryFlatFeePricing' } },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'priceInMinorUnits' } }] },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryTieredFlatFeePricing' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'priceTiers' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'minQuantity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalPriceInMinorUnits' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryTieredPricing' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'priceTiers' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'minQuantity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'unitPriceInMinorUnits' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StationeryShippingConstraints' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryProductShippingOptionV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'constraints' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryAllowPoBoxShippingConstraint' } },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'allowPoBox' } }] },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryCountryShippingConstraint' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'includedCountries' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'excludedCountries' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryQuantityShippingConstraint' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'minQuantity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maxQuantity' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StationeryProductAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryProduct' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'attributeId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attributeOptions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StationeryProductAttributePricings' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributeOption' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'attributeId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StationeryProductAttributePricings' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryProductAttributeOption' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pricing' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryTieredPricing' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'priceTiers' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'minQuantity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'unitPriceInMinorUnits' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryTieredFlatFeePricing' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'priceTiers' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'minQuantity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalPriceInMinorUnits' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryFlatFeePricing' } },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'priceInMinorUnits' } }] },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StationeryProductPricings' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryProduct' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priceCurrency' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pricing' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryTieredPricing' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'priceTiers' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'minQuantity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'unitPriceInMinorUnits' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryTieredFlatFeePricing' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'priceTiers' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'minQuantity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalPriceInMinorUnits' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryFlatFeePricing' } },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'priceInMinorUnits' } }] },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StationeryProductVariantGroups' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryProduct' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'variantGroups' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'vendorSKU' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'options' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'attributeId' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetStationaryPrintOrderByOrderNumberQuery__
 *
 * To run a query within a React component, call `useGetStationaryPrintOrderByOrderNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStationaryPrintOrderByOrderNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStationaryPrintOrderByOrderNumberQuery({
 *   variables: {
 *      orderNumber: // value for 'orderNumber'
 *   },
 * });
 */
export function useGetStationaryPrintOrderByOrderNumberQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetStationaryPrintOrderByOrderNumberQuery, GetStationaryPrintOrderByOrderNumberQueryVariables>,
) {
  return ApolloReactHooks.useQuery<GetStationaryPrintOrderByOrderNumberQuery, GetStationaryPrintOrderByOrderNumberQueryVariables>(
    GetStationaryPrintOrderByOrderNumberDocument,
    baseOptions,
  );
}
export function useGetStationaryPrintOrderByOrderNumberLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStationaryPrintOrderByOrderNumberQuery, GetStationaryPrintOrderByOrderNumberQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetStationaryPrintOrderByOrderNumberQuery, GetStationaryPrintOrderByOrderNumberQueryVariables>(
    GetStationaryPrintOrderByOrderNumberDocument,
    baseOptions,
  );
}
export type GetStationaryPrintOrderByOrderNumberQueryHookResult = ReturnType<typeof useGetStationaryPrintOrderByOrderNumberQuery>;
export type GetStationaryPrintOrderByOrderNumberLazyQueryHookResult = ReturnType<typeof useGetStationaryPrintOrderByOrderNumberLazyQuery>;
export type GetStationaryPrintOrderByOrderNumberQueryResult = Apollo.QueryResult<GetStationaryPrintOrderByOrderNumberQuery, GetStationaryPrintOrderByOrderNumberQueryVariables>;
export const GetEventPrivacyForCardCustomizerDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetEventPrivacyForCardCustomizer' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventById' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'info' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasEventPassword' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'privacyMode' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetEventPrivacyForCardCustomizerQuery__
 *
 * To run a query within a React component, call `useGetEventPrivacyForCardCustomizerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventPrivacyForCardCustomizerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventPrivacyForCardCustomizerQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetEventPrivacyForCardCustomizerQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventPrivacyForCardCustomizerQuery, GetEventPrivacyForCardCustomizerQueryVariables>,
) {
  return ApolloReactHooks.useQuery<GetEventPrivacyForCardCustomizerQuery, GetEventPrivacyForCardCustomizerQueryVariables>(GetEventPrivacyForCardCustomizerDocument, baseOptions);
}
export function useGetEventPrivacyForCardCustomizerLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventPrivacyForCardCustomizerQuery, GetEventPrivacyForCardCustomizerQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetEventPrivacyForCardCustomizerQuery, GetEventPrivacyForCardCustomizerQueryVariables>(
    GetEventPrivacyForCardCustomizerDocument,
    baseOptions,
  );
}
export type GetEventPrivacyForCardCustomizerQueryHookResult = ReturnType<typeof useGetEventPrivacyForCardCustomizerQuery>;
export type GetEventPrivacyForCardCustomizerLazyQueryHookResult = ReturnType<typeof useGetEventPrivacyForCardCustomizerLazyQuery>;
export type GetEventPrivacyForCardCustomizerQueryResult = Apollo.QueryResult<GetEventPrivacyForCardCustomizerQuery, GetEventPrivacyForCardCustomizerQueryVariables>;
export const CreateStationeryDraftPreviewDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateStationeryDraftPreview' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateStationeryDraftPreviewInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createStationeryDraftPreview' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'data' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'stationeryPDF' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stationeryFrontImage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stationeryBackImage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'envelopePDF' } },
                { kind: 'Field', name: { kind: 'Name', value: 'envelopeFrontImage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'envelopeBackImage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postcardBacksPDF' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postcardBackImage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postcardInterleavedPDF' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateStationeryDraftPreviewMutationFn = Apollo.MutationFunction<CreateStationeryDraftPreviewMutation, CreateStationeryDraftPreviewMutationVariables>;

/**
 * __useCreateStationeryDraftPreviewMutation__
 *
 * To run a mutation, you first call `useCreateStationeryDraftPreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStationeryDraftPreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStationeryDraftPreviewMutation, { data, loading, error }] = useCreateStationeryDraftPreviewMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateStationeryDraftPreviewMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<CreateStationeryDraftPreviewMutation, CreateStationeryDraftPreviewMutationVariables>,
) {
  return ApolloReactHooks.useMutation<CreateStationeryDraftPreviewMutation, CreateStationeryDraftPreviewMutationVariables>(CreateStationeryDraftPreviewDocument, baseOptions);
}
export type CreateStationeryDraftPreviewMutationHookResult = ReturnType<typeof useCreateStationeryDraftPreviewMutation>;
export type CreateStationeryDraftPreviewMutationResult = Apollo.MutationResult<CreateStationeryDraftPreviewMutation>;
export type CreateStationeryDraftPreviewMutationOptions = Apollo.BaseMutationOptions<CreateStationeryDraftPreviewMutation, CreateStationeryDraftPreviewMutationVariables>;
export const CreateStationeryDigitalDraftPreviewDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateStationeryDigitalDraftPreview' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateStationeryDraftPreviewInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createStationeryDigitalDraftPreview' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'data' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'stationeryFrontImage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stationeryBackImage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'digitalEnvelopeImage' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateStationeryDigitalDraftPreviewMutationFn = Apollo.MutationFunction<
  CreateStationeryDigitalDraftPreviewMutation,
  CreateStationeryDigitalDraftPreviewMutationVariables
>;

/**
 * __useCreateStationeryDigitalDraftPreviewMutation__
 *
 * To run a mutation, you first call `useCreateStationeryDigitalDraftPreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStationeryDigitalDraftPreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStationeryDigitalDraftPreviewMutation, { data, loading, error }] = useCreateStationeryDigitalDraftPreviewMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateStationeryDigitalDraftPreviewMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<CreateStationeryDigitalDraftPreviewMutation, CreateStationeryDigitalDraftPreviewMutationVariables>,
) {
  return ApolloReactHooks.useMutation<CreateStationeryDigitalDraftPreviewMutation, CreateStationeryDigitalDraftPreviewMutationVariables>(
    CreateStationeryDigitalDraftPreviewDocument,
    baseOptions,
  );
}
export type CreateStationeryDigitalDraftPreviewMutationHookResult = ReturnType<typeof useCreateStationeryDigitalDraftPreviewMutation>;
export type CreateStationeryDigitalDraftPreviewMutationResult = Apollo.MutationResult<CreateStationeryDigitalDraftPreviewMutation>;
export type CreateStationeryDigitalDraftPreviewMutationOptions = Apollo.BaseMutationOptions<
  CreateStationeryDigitalDraftPreviewMutation,
  CreateStationeryDigitalDraftPreviewMutationVariables
>;
export const UpdateStationeryDraftDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateStationeryDraft' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateStationeryDraftInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateStationeryDraft' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'data' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cardJSON' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateStationeryDraftMutationFn = Apollo.MutationFunction<UpdateStationeryDraftMutation, UpdateStationeryDraftMutationVariables>;

/**
 * __useUpdateStationeryDraftMutation__
 *
 * To run a mutation, you first call `useUpdateStationeryDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStationeryDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStationeryDraftMutation, { data, loading, error }] = useUpdateStationeryDraftMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateStationeryDraftMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateStationeryDraftMutation, UpdateStationeryDraftMutationVariables>) {
  return ApolloReactHooks.useMutation<UpdateStationeryDraftMutation, UpdateStationeryDraftMutationVariables>(UpdateStationeryDraftDocument, baseOptions);
}
export type UpdateStationeryDraftMutationHookResult = ReturnType<typeof useUpdateStationeryDraftMutation>;
export type UpdateStationeryDraftMutationResult = Apollo.MutationResult<UpdateStationeryDraftMutation>;
export type UpdateStationeryDraftMutationOptions = Apollo.BaseMutationOptions<UpdateStationeryDraftMutation, UpdateStationeryDraftMutationVariables>;
export const CreateStationeryPrintOrderDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateStationeryPrintOrder' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateStationeryPrintOrderInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createStationeryPrintOrder' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'data' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateStationeryPrintOrderMutationFn = Apollo.MutationFunction<CreateStationeryPrintOrderMutation, CreateStationeryPrintOrderMutationVariables>;

/**
 * __useCreateStationeryPrintOrderMutation__
 *
 * To run a mutation, you first call `useCreateStationeryPrintOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStationeryPrintOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStationeryPrintOrderMutation, { data, loading, error }] = useCreateStationeryPrintOrderMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateStationeryPrintOrderMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<CreateStationeryPrintOrderMutation, CreateStationeryPrintOrderMutationVariables>,
) {
  return ApolloReactHooks.useMutation<CreateStationeryPrintOrderMutation, CreateStationeryPrintOrderMutationVariables>(CreateStationeryPrintOrderDocument, baseOptions);
}
export type CreateStationeryPrintOrderMutationHookResult = ReturnType<typeof useCreateStationeryPrintOrderMutation>;
export type CreateStationeryPrintOrderMutationResult = Apollo.MutationResult<CreateStationeryPrintOrderMutation>;
export type CreateStationeryPrintOrderMutationOptions = Apollo.BaseMutationOptions<CreateStationeryPrintOrderMutation, CreateStationeryPrintOrderMutationVariables>;
export const AddStationeryCartItemDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddStationeryCartItem' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateStationeryPrintOrderInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addStationeryCartItem' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'data' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type AddStationeryCartItemMutationFn = Apollo.MutationFunction<AddStationeryCartItemMutation, AddStationeryCartItemMutationVariables>;

/**
 * __useAddStationeryCartItemMutation__
 *
 * To run a mutation, you first call `useAddStationeryCartItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddStationeryCartItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addStationeryCartItemMutation, { data, loading, error }] = useAddStationeryCartItemMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddStationeryCartItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddStationeryCartItemMutation, AddStationeryCartItemMutationVariables>) {
  return ApolloReactHooks.useMutation<AddStationeryCartItemMutation, AddStationeryCartItemMutationVariables>(AddStationeryCartItemDocument, baseOptions);
}
export type AddStationeryCartItemMutationHookResult = ReturnType<typeof useAddStationeryCartItemMutation>;
export type AddStationeryCartItemMutationResult = Apollo.MutationResult<AddStationeryCartItemMutation>;
export type AddStationeryCartItemMutationOptions = Apollo.BaseMutationOptions<AddStationeryCartItemMutation, AddStationeryCartItemMutationVariables>;
export const StartStationeryCheckoutDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'StartStationeryCheckout' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'StartStationeryCheckoutInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'startStationeryCheckout' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'data' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'checkoutUrl' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type StartStationeryCheckoutMutationFn = Apollo.MutationFunction<StartStationeryCheckoutMutation, StartStationeryCheckoutMutationVariables>;

/**
 * __useStartStationeryCheckoutMutation__
 *
 * To run a mutation, you first call `useStartStationeryCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartStationeryCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startStationeryCheckoutMutation, { data, loading, error }] = useStartStationeryCheckoutMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useStartStationeryCheckoutMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StartStationeryCheckoutMutation, StartStationeryCheckoutMutationVariables>) {
  return ApolloReactHooks.useMutation<StartStationeryCheckoutMutation, StartStationeryCheckoutMutationVariables>(StartStationeryCheckoutDocument, baseOptions);
}
export type StartStationeryCheckoutMutationHookResult = ReturnType<typeof useStartStationeryCheckoutMutation>;
export type StartStationeryCheckoutMutationResult = Apollo.MutationResult<StartStationeryCheckoutMutation>;
export type StartStationeryCheckoutMutationOptions = Apollo.BaseMutationOptions<StartStationeryCheckoutMutation, StartStationeryCheckoutMutationVariables>;
export const DeleteStationeryPrintOrderForFailedCheckoutUrlDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteStationeryPrintOrderForFailedCheckoutUrl' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteStationeryPrintOrderForFailedCheckoutUrl' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type DeleteStationeryPrintOrderForFailedCheckoutUrlMutationFn = Apollo.MutationFunction<
  DeleteStationeryPrintOrderForFailedCheckoutUrlMutation,
  DeleteStationeryPrintOrderForFailedCheckoutUrlMutationVariables
>;

/**
 * __useDeleteStationeryPrintOrderForFailedCheckoutUrlMutation__
 *
 * To run a mutation, you first call `useDeleteStationeryPrintOrderForFailedCheckoutUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStationeryPrintOrderForFailedCheckoutUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStationeryPrintOrderForFailedCheckoutUrlMutation, { data, loading, error }] = useDeleteStationeryPrintOrderForFailedCheckoutUrlMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteStationeryPrintOrderForFailedCheckoutUrlMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteStationeryPrintOrderForFailedCheckoutUrlMutation, DeleteStationeryPrintOrderForFailedCheckoutUrlMutationVariables>,
) {
  return ApolloReactHooks.useMutation<DeleteStationeryPrintOrderForFailedCheckoutUrlMutation, DeleteStationeryPrintOrderForFailedCheckoutUrlMutationVariables>(
    DeleteStationeryPrintOrderForFailedCheckoutUrlDocument,
    baseOptions,
  );
}
export type DeleteStationeryPrintOrderForFailedCheckoutUrlMutationHookResult = ReturnType<typeof useDeleteStationeryPrintOrderForFailedCheckoutUrlMutation>;
export type DeleteStationeryPrintOrderForFailedCheckoutUrlMutationResult = Apollo.MutationResult<DeleteStationeryPrintOrderForFailedCheckoutUrlMutation>;
export type DeleteStationeryPrintOrderForFailedCheckoutUrlMutationOptions = Apollo.BaseMutationOptions<
  DeleteStationeryPrintOrderForFailedCheckoutUrlMutation,
  DeleteStationeryPrintOrderForFailedCheckoutUrlMutationVariables
>;
export const UpdateWebsiteHandleDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateWebsiteHandle' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'website' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateWebsiteHandle' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'website' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'website' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'website' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateWebsiteHandleMutationFn = Apollo.MutationFunction<UpdateWebsiteHandleMutation, UpdateWebsiteHandleMutationVariables>;

/**
 * __useUpdateWebsiteHandleMutation__
 *
 * To run a mutation, you first call `useUpdateWebsiteHandleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWebsiteHandleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWebsiteHandleMutation, { data, loading, error }] = useUpdateWebsiteHandleMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      website: // value for 'website'
 *   },
 * });
 */
export function useUpdateWebsiteHandleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateWebsiteHandleMutation, UpdateWebsiteHandleMutationVariables>) {
  return ApolloReactHooks.useMutation<UpdateWebsiteHandleMutation, UpdateWebsiteHandleMutationVariables>(UpdateWebsiteHandleDocument, baseOptions);
}
export type UpdateWebsiteHandleMutationHookResult = ReturnType<typeof useUpdateWebsiteHandleMutation>;
export type UpdateWebsiteHandleMutationResult = Apollo.MutationResult<UpdateWebsiteHandleMutation>;
export type UpdateWebsiteHandleMutationOptions = Apollo.BaseMutationOptions<UpdateWebsiteHandleMutation, UpdateWebsiteHandleMutationVariables>;
export const CreateQRCodeDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateQRCode' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateQRCodeInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createQRCode' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'data' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateQRCodeMutationFn = Apollo.MutationFunction<CreateQRCodeMutation, CreateQRCodeMutationVariables>;

/**
 * __useCreateQRCodeMutation__
 *
 * To run a mutation, you first call `useCreateQRCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQRCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQrCodeMutation, { data, loading, error }] = useCreateQRCodeMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateQRCodeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateQRCodeMutation, CreateQRCodeMutationVariables>) {
  return ApolloReactHooks.useMutation<CreateQRCodeMutation, CreateQRCodeMutationVariables>(CreateQRCodeDocument, baseOptions);
}
export type CreateQRCodeMutationHookResult = ReturnType<typeof useCreateQRCodeMutation>;
export type CreateQRCodeMutationResult = Apollo.MutationResult<CreateQRCodeMutation>;
export type CreateQRCodeMutationOptions = Apollo.BaseMutationOptions<CreateQRCodeMutation, CreateQRCodeMutationVariables>;
export const EditStationeryPrintOrderDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'EditStationeryPrintOrder' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'EditStationeryPrintOrderInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'editStationeryPrintOrder' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'data' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StationeryPrintOrderDetails' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OrderProductDetails' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryPrintOrder' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'product' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'priceConfigId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'productType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vendorBaseSKU' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StationeryShippingOptions' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StationeryProductAttributes' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StationeryProductPricings' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StationeryProductVariantGroups' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StationeryShippingOptions' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryProduct' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shippingOptions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryProductShippingOptionV1' } },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ShippingOptionV1' } }] },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ShippingOptionV1' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryProductShippingOptionV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StationeryShippingOptionsPricing' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StationeryShippingConstraints' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StationeryShippingOptionsPricing' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryProductShippingOptionV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pricing' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryFlatFeePricing' } },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'priceInMinorUnits' } }] },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryTieredFlatFeePricing' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'priceTiers' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'minQuantity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalPriceInMinorUnits' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryTieredPricing' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'priceTiers' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'minQuantity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'unitPriceInMinorUnits' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StationeryShippingConstraints' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryProductShippingOptionV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'constraints' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryAllowPoBoxShippingConstraint' } },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'allowPoBox' } }] },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryCountryShippingConstraint' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'includedCountries' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'excludedCountries' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryQuantityShippingConstraint' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'minQuantity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maxQuantity' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StationeryProductAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryProduct' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'attributeId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attributeOptions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StationeryProductAttributePricings' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributeOption' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'attributeId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StationeryProductAttributePricings' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryProductAttributeOption' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pricing' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryTieredPricing' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'priceTiers' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'minQuantity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'unitPriceInMinorUnits' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryTieredFlatFeePricing' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'priceTiers' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'minQuantity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalPriceInMinorUnits' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryFlatFeePricing' } },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'priceInMinorUnits' } }] },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StationeryProductPricings' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryProduct' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priceCurrency' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pricing' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryTieredPricing' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'priceTiers' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'minQuantity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'unitPriceInMinorUnits' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryTieredFlatFeePricing' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'priceTiers' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'minQuantity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalPriceInMinorUnits' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryFlatFeePricing' } },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'priceInMinorUnits' } }] },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StationeryProductVariantGroups' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryProduct' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'variantGroups' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'vendorSKU' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'options' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'attributeId' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StationeryPrintOrderDetails' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryPrintOrder' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'OrderProductDetails' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'OrderSelectedProductInfo' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'statusHistory' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orderId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'date' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryMethod' } },
          { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priceInMinorUnits' } },
          { kind: 'Field', name: { kind: 'Name', value: 'taxInMinorUnits' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currencyConversionData' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currencyISO4217' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pricingAsCustomized' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shippingAddress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'region' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'printPayment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'paid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'paidAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'creditCardBrand' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'creditCardLast4' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cardDraft' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'format' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stationeryTemplate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'themeId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'products' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'productType' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'cardDraftJSONBlob' } },
          { kind: 'Field', name: { kind: 'Name', value: 'digitalFeatures' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'trackingNumbers' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'trackingUrl' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'printCardFrontPreviewUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'printCardBackPreviewUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postcardBackImageUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'envelopeFrontImageUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'envelopeBackImageUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stationeryPDFUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postcardInterleavedPDFUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'envelopePDFUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'refunds' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'refundAmountInMinorUnits' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'discount' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', alias: { kind: 'Name', value: 'discountAmountInMinorUnits' }, name: { kind: 'Name', value: 'amountInMinorUnits' } },
                { kind: 'Field', alias: { kind: 'Name', value: 'discountPercentage' }, name: { kind: 'Name', value: 'percentage' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'designSetName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'magnetCard' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issues' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resolvedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'issueType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'issueTarget' } },
                { kind: 'Field', name: { kind: 'Name', value: 'additionalUserFacingDescription' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OrderSelectedProductInfo' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryPrintOrder' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selectedProduct' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attributes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'attributeId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'optionId' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type EditStationeryPrintOrderMutationFn = Apollo.MutationFunction<EditStationeryPrintOrderMutation, EditStationeryPrintOrderMutationVariables>;

/**
 * __useEditStationeryPrintOrderMutation__
 *
 * To run a mutation, you first call `useEditStationeryPrintOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditStationeryPrintOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editStationeryPrintOrderMutation, { data, loading, error }] = useEditStationeryPrintOrderMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useEditStationeryPrintOrderMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<EditStationeryPrintOrderMutation, EditStationeryPrintOrderMutationVariables>,
) {
  return ApolloReactHooks.useMutation<EditStationeryPrintOrderMutation, EditStationeryPrintOrderMutationVariables>(EditStationeryPrintOrderDocument, baseOptions);
}
export type EditStationeryPrintOrderMutationHookResult = ReturnType<typeof useEditStationeryPrintOrderMutation>;
export type EditStationeryPrintOrderMutationResult = Apollo.MutationResult<EditStationeryPrintOrderMutation>;
export type EditStationeryPrintOrderMutationOptions = Apollo.BaseMutationOptions<EditStationeryPrintOrderMutation, EditStationeryPrintOrderMutationVariables>;
export const CreateAndStartCheckoutDigitalPrintOrderDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateAndStartCheckoutDigitalPrintOrder' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateDigitalPrintOrderInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createAndStartCheckoutDigitalPrintOrder' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'data' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'checkoutUrl' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateAndStartCheckoutDigitalPrintOrderMutationFn = Apollo.MutationFunction<
  CreateAndStartCheckoutDigitalPrintOrderMutation,
  CreateAndStartCheckoutDigitalPrintOrderMutationVariables
>;

/**
 * __useCreateAndStartCheckoutDigitalPrintOrderMutation__
 *
 * To run a mutation, you first call `useCreateAndStartCheckoutDigitalPrintOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAndStartCheckoutDigitalPrintOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAndStartCheckoutDigitalPrintOrderMutation, { data, loading, error }] = useCreateAndStartCheckoutDigitalPrintOrderMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateAndStartCheckoutDigitalPrintOrderMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAndStartCheckoutDigitalPrintOrderMutation, CreateAndStartCheckoutDigitalPrintOrderMutationVariables>,
) {
  return ApolloReactHooks.useMutation<CreateAndStartCheckoutDigitalPrintOrderMutation, CreateAndStartCheckoutDigitalPrintOrderMutationVariables>(
    CreateAndStartCheckoutDigitalPrintOrderDocument,
    baseOptions,
  );
}
export type CreateAndStartCheckoutDigitalPrintOrderMutationHookResult = ReturnType<typeof useCreateAndStartCheckoutDigitalPrintOrderMutation>;
export type CreateAndStartCheckoutDigitalPrintOrderMutationResult = Apollo.MutationResult<CreateAndStartCheckoutDigitalPrintOrderMutation>;
export type CreateAndStartCheckoutDigitalPrintOrderMutationOptions = Apollo.BaseMutationOptions<
  CreateAndStartCheckoutDigitalPrintOrderMutation,
  CreateAndStartCheckoutDigitalPrintOrderMutationVariables
>;
export const AddStationeryPrintOrderIssuesDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddStationeryPrintOrderIssues' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'stationeryPrintOrderId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'ListType', type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateStationeryPrintOrderIssueInput' } } } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addStationeryPrintOrderIssues' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'stationeryPrintOrderId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'stationeryPrintOrderId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'data' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'resolvedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'issueType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'issueTarget' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type AddStationeryPrintOrderIssuesMutationFn = Apollo.MutationFunction<AddStationeryPrintOrderIssuesMutation, AddStationeryPrintOrderIssuesMutationVariables>;

/**
 * __useAddStationeryPrintOrderIssuesMutation__
 *
 * To run a mutation, you first call `useAddStationeryPrintOrderIssuesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddStationeryPrintOrderIssuesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addStationeryPrintOrderIssuesMutation, { data, loading, error }] = useAddStationeryPrintOrderIssuesMutation({
 *   variables: {
 *      stationeryPrintOrderId: // value for 'stationeryPrintOrderId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddStationeryPrintOrderIssuesMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<AddStationeryPrintOrderIssuesMutation, AddStationeryPrintOrderIssuesMutationVariables>,
) {
  return ApolloReactHooks.useMutation<AddStationeryPrintOrderIssuesMutation, AddStationeryPrintOrderIssuesMutationVariables>(AddStationeryPrintOrderIssuesDocument, baseOptions);
}
export type AddStationeryPrintOrderIssuesMutationHookResult = ReturnType<typeof useAddStationeryPrintOrderIssuesMutation>;
export type AddStationeryPrintOrderIssuesMutationResult = Apollo.MutationResult<AddStationeryPrintOrderIssuesMutation>;
export type AddStationeryPrintOrderIssuesMutationOptions = Apollo.BaseMutationOptions<AddStationeryPrintOrderIssuesMutation, AddStationeryPrintOrderIssuesMutationVariables>;
export const ResolveStationeryPrintOrderIssueDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ResolveStationeryPrintOrderIssue' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'stationeryPrintOrderId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'issueId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resolveStationeryPrintOrderIssue' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'stationeryPrintOrderId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'stationeryPrintOrderId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'issueId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'issueId' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'resolvedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'issueType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'issueTarget' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'additionalUserFacingDescription' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ResolveStationeryPrintOrderIssueMutationFn = Apollo.MutationFunction<ResolveStationeryPrintOrderIssueMutation, ResolveStationeryPrintOrderIssueMutationVariables>;

/**
 * __useResolveStationeryPrintOrderIssueMutation__
 *
 * To run a mutation, you first call `useResolveStationeryPrintOrderIssueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveStationeryPrintOrderIssueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveStationeryPrintOrderIssueMutation, { data, loading, error }] = useResolveStationeryPrintOrderIssueMutation({
 *   variables: {
 *      stationeryPrintOrderId: // value for 'stationeryPrintOrderId'
 *      issueId: // value for 'issueId'
 *   },
 * });
 */
export function useResolveStationeryPrintOrderIssueMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<ResolveStationeryPrintOrderIssueMutation, ResolveStationeryPrintOrderIssueMutationVariables>,
) {
  return ApolloReactHooks.useMutation<ResolveStationeryPrintOrderIssueMutation, ResolveStationeryPrintOrderIssueMutationVariables>(
    ResolveStationeryPrintOrderIssueDocument,
    baseOptions,
  );
}
export type ResolveStationeryPrintOrderIssueMutationHookResult = ReturnType<typeof useResolveStationeryPrintOrderIssueMutation>;
export type ResolveStationeryPrintOrderIssueMutationResult = Apollo.MutationResult<ResolveStationeryPrintOrderIssueMutation>;
export type ResolveStationeryPrintOrderIssueMutationOptions = Apollo.BaseMutationOptions<
  ResolveStationeryPrintOrderIssueMutation,
  ResolveStationeryPrintOrderIssueMutationVariables
>;
